export default __webpack_public_path__ + "static/media/022-rum.9131b394.png";